<template>
  <tr>
    <th>
      미확인 알림
      <br />(snooze)
    </th>
    <td>
      <div class="form_group type_radio" v-for="val in maxList">
        <input type="radio" :name="`snooze_${uuid}`" :id="`snooze${val}${uuid}`" :value="val" v-model="snoozeMax_local" :key="val" />
        <label :for="`snooze${val}${uuid}`">{{ val ? `${val}회` : '안함' }}</label>
      </div>
      <div class="form_group">
        <select title="미확인 알림 간격" v-model="snoozeInterval_local" :disabled="!snoozeMax_local" ref="snoozeIntervalBox">
          <option v-for="val in intervalList" :key="val" :value="val">{{ val ? `${val}시간` : '안함' }}</option>
        </select>
      </div>
      <p v-if="messageType === 'register'" class="caution">
        <span class="ico">*</span> 어르신이 소식을 확인하지 않은 경우, 지정된 시간 후에 자동 Push 알림 재발송. <br />단, 야간 시간은
        설정해도 발송하지 않음.
      </p>
      <p v-else-if="messageType === 'updater'" class="caution">
        <!-- <span class="ico">*</span> snooze 수정사항은 내일부터 반영됩니다. -->
      </p>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    hasSnooze: Boolean,
    snoozeMax: Number,
    snoozeInterval: Number,
    maxList: {
      type: Array,
      default: () => [0, 1, 2, 3],
    },
    intervalList: {
      type: Array,
      default: () => [0, 1, 2, 3, 6, 12, 24],
    },
    messageType: {
      type: String,
      default: 'register', // register, updater
    },
  },
  data() {
    return {
      snoozeMax_local: this.snoozeMax,
      snoozeInterval_local: this.snoozeInterval,
    };
  },
  watch: {
    snoozeInterval_local(val) {
      this.$emit('update:snoozeInterval', val);
    },
    snoozeMax_local(val) {
      this.$emit('update:snoozeMax', val);
    },
    hasSnooze_local(val) {
      this.$emit('update:hasSnooze', val);
    },
  },
  computed: {
    hasSnooze_local() {
      return Boolean(this.snoozeMax_local);
    },
  },
  methods: {
    validate() {
      if (this.snoozeMax && !this.snoozeInterval) {
        alert('미확인 알림 시간 간격을 설정해 주세요.');
        this.$refs.snoozeIntervalBox.focus();
        return false;
      }
      return true;
    },
  },
};
</script>

<style></style>
